<script>
import { mapGetters, mapState } from 'vuex'
export default {
	props: { },
	data: function() { return { }; },
    methods: { },
	created: function() {
		this.$store.dispatch('campanhapontos/getSaldoCampanhaPontos');
		this.$store.dispatch('campanhapontos/getPremiosSelecionados');
		this.$store.dispatch('campanhapontos/getMeusResgates');
	},
    computed: {
        ...mapState({
            saldoCampanhaPontos: state => state.campanhapontos.saldoCampanhaPontos,
            premios: state => state.campanhapontos.premios,
            resgates: state => state.campanhapontos.resgates,
        	isLoading: state => state.campanhapontos.isLoading
            }),
        ...mapGetters('campanhapontos', { }),
        countPremiosSelecionados: function() { return this.premios.length; }
    }	
};
</script>